import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import MinusAdjustment from "../../assets/max-adjustment.svg";
import MinAdjustment from "../../assets/add-icon.svg";
import addplus from "../../assets/addplusicon.png";
import upload from "../../assets/upload.svg";
import { isEmpty } from "lodash";

interface ListData {
  value: string;
}

interface AttachmentData {
  imageData: string;
  imageType: string;
  updateStatus: boolean;
  priority?: string;
  errorMessage?: string;
}

interface RowData {
  title: string;
  description: string;
  list: ListData[];
  attachment: AttachmentData[];
  errorMessage?: string;
  successMessage?: string;
  imageName: ''
}

interface ContentAddProps {
  rows: RowData[];
  updateRow: (index: number, newData: Partial<RowData>) => void;
  handleAddRow: () => void;
  handleRemoveRow: (index: number, id: any) => void;
  handleImageClose: (rowIndex: number, listIndex: any) => void;
  handleAddList: (rowIndex: number) => void;
  handleRemoveList: (rowIndex: number, listIndex: number, id: any) => void;
  handleRemoveFileoneUpload: (rowID: number, fileIndex: any, fileId: number) => void;
}

const ContentAdd: React.FC<ContentAddProps> = ({
  rows = [], // Provide default empty array
  updateRow,
  handleAddRow,
  handleRemoveRow,
  handleAddList,
  handleRemoveList,
  handleImageClose,
  handleRemoveFileoneUpload
}) => {
  // Ensure each row has an initialized attachment array
  const safeRows: any = rows.map((row) => ({
    ...row,
    attachment: row.attachment || [],
  }));

  const [removedImageRowIds, setRemovedImageRowIds] = useState<number[]>([]);


  const validateFile = (file: File, rowIndex: number, fileIndex: number) => {
    const validTypes = ["image/jpeg", "image/png", "image/svg+xml"];
    if (!validTypes.includes(file.type)) {
      updateAttachmentError(rowIndex, fileIndex, "Unsupported file format. Please upload JPEG, PNG, or SVG.");
      return false;
    }
    return true;
  };


  const validateImageDimensions = (file: File, rowIndex: number, fileIndex: number,id:any) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);

    img.onload = () => {
      const isValid = img.width >= 484 && img.height >= 530;
      if (isValid) {
        const imageType = file.type.replace("image/", "");
        convertFileToBase64(file, rowIndex, imageType, fileIndex,id);
      } else {
        updateAttachmentError(rowIndex, fileIndex, "Image must be at least 484px wide and 530px tall.");
      }
      URL.revokeObjectURL(img.src);
    };

    img.onerror = () => {
      updateAttachmentError(rowIndex, fileIndex, "Could not load image to validate dimensions.");
    };
  };

  const handleFileChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    rowIndex: number,
    fileIndex: number,
    id:any
  ) => {
    const file = event.target.files?.[0];
    if (file && validateFile(file, rowIndex, fileIndex)) {
      validateImageDimensions(file, rowIndex, fileIndex,id);
    }
  };

  const convertFileToBase64 = (
    file: File,
    rowIndex: number,
    imageType: string,
    fileIndex: number,
    id:any
  ) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      const base64data = reader.result as string;
      const currentAttachments = safeRows[rowIndex].attachment || [];
      const newAttachments = [...currentAttachments];
      newAttachments[fileIndex] = {
        imageData: base64data,
        imageType: imageType,
        updateStatus: true,
        priority: newAttachments[fileIndex]?.priority || "",
        errorMessage: "",
        id:id
      };
      updateRow(rowIndex, {
        attachment: newAttachments,
        successMessage: "File uploaded successfully!",
      });
    };
    reader.onerror = () => {
      updateAttachmentError(rowIndex, fileIndex, "Error converting file to Base64.");
    };
  };

  const updateAttachmentError = (rowIndex: number, fileIndex: number, message: string) => {
    const currentAttachments = safeRows[rowIndex].attachment || [];
    const newAttachments = [...currentAttachments];
    newAttachments[fileIndex] = {
      ...newAttachments[fileIndex],
      errorMessage: message,
    };
    updateRow(rowIndex, { attachment: newAttachments });
  };

  const handleDrop = (
    event: React.DragEvent<HTMLDivElement>,
    rowIndex: number,
    fileIndex: number,
    id:any
  ) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file && validateFile(file, rowIndex, fileIndex)) {
      const imageType = file.type;
      convertFileToBase64(file, rowIndex, imageType, fileIndex,id);
    }
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const handleAddFileUpload = (rowIndex: number) => {
    const currentAttachments = safeRows[rowIndex].attachment || [];
    const newAttachments = [
      ...currentAttachments,
      {
        imageData: "",
        imageType: "",
        updateStatus: true,
        priority: "",
      },
    ];
    updateRow(rowIndex, { attachment: newAttachments });
  };

  const handleRemoveFileUpload = (rowIndex: number, fileIndex: number, fileId: any) => {
console.log("sakthi");
handleRemoveFileoneUpload(rowIndex, fileIndex ,fileId)
    // setRemovedImageRowIds((prevRemovedRowIds) => [...prevRemovedRowIds, id]);
    const currentAttachments = safeRows[rowIndex].attachment || [];
    const newAttachments = currentAttachments.filter(
      (_: any, index: any) => index !== fileIndex
    );
    updateRow(rowIndex, { attachment: newAttachments });
  };

  useEffect(() => {
    console.log("array---removedImageRowIds--->", removedImageRowIds);
  }, [removedImageRowIds]);

  const getFilteredOptions = (rowIndex: any, fileIndex: any) => {
    const selectedOptions = rows && rows[rowIndex].attachment
      .map((file) => file.priority)
      .filter((id) => id && id !== rows[rowIndex].attachment[fileIndex].priority);

    // Filter out options that are already selected within the same row
    return ["1", "2", "3"].filter((option) => !selectedOptions.includes(option));
  };

  // Your existing handlePriorityChange function
  const handlePriorityChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
    rowIndex: number,
    fileIndex: number,
    id:any
  ) => {
    const newpriority = event.target.value;
    const updatedAttachments = rows[rowIndex].attachment.map((att, idx) =>
      idx === fileIndex ? { ...att, priority: newpriority,id:id } : att
    
    );
    {
    }
    
    updateRow(rowIndex, { attachment: updatedAttachments });
  };

  return (
    <div>
      {safeRows.map((row: any, rowIndex: any) => (
        <Row key={rowIndex} className="mb-4">
          <Col md="3" lg="3" className="">
            <input
              type="text"
              className="form-control bgborder"
              placeholder="Enter Title"
              minLength={2}
              value={row.title}
              // onChange={(e) => updateRow(rowIndex, { title: e.target.value })}
              onChange={(e) => {
                const sanitizedValue = e.target.value.replace(/ {2,}/g, ' ');  // Replaces multiple spaces with one
                updateRow(rowIndex, { title: sanitizedValue });
              }}
            />
          </Col>
          <Col
            md="4"
            lg="4"
            className=""
            style={{ paddingBottom: "10px" }}
          >
            <textarea
              className="form-control bgborder"
              placeholder="Enter Description"
              value={row.description}
              // required={!!row.title}
              // onChange={(e) => {
              //   const updatedValue = e.target.value;
              //   console.log("Updated Description:", updatedValue); 
              //   updateRow(rowIndex, { description: updatedValue }); 
              // }}
              onChange={(e) => {
                const sanitizedValue = e.target.value.replace(/ {2,}/g, ' ');  // Replaces multiple spaces with one
                updateRow(rowIndex, { description: sanitizedValue });
              }}
            
            />
          </Col>

          <Col md="4" lg="4">
            <label>Add List</label>
            {row.list.map((list: any, listIndex: any) => (
              <div key={listIndex} className="d-flex align-items-center pb-3">
                <input
                  type="text"
                  className="form-control bgborder"
                  placeholder="List Title"
                  minLength={2}
                  value={list.value}
              // required={!!row.title}

                  // onChange={(e) => {
                  //   const updatedLists = row.list.map((l: any, i: any) =>
                  //     i === listIndex ? { value: e.target.value, id : list.id } : l
                  //   );
                  //   updateRow(rowIndex, { list: updatedLists });
                  // }}
                  onChange={(e) => {
                    const sanitizedValue = e.target.value.replace(/ {2,}/g, ' ');  // Replaces multiple spaces with one
                    const updatedLists = row.list.map((l: any, i: any) =>
                      i === listIndex ? { value: sanitizedValue, id: list.id } : l
                    );
                    updateRow(rowIndex, { list: updatedLists });
                  }}

                />
                <img
                  style={{
                    width: "28px",
                    cursor: "pointer",
                    marginLeft: "5px",
                  }}
                  src={MinusAdjustment}
                  alt="Remove list"
                  onClick={() => handleRemoveList(rowIndex, listIndex, list.id)}
                />
              </div>
            ))}
          </Col>
          <Col md="1" lg="1" className="flexalignitemcenter">
            <img
              style={{ width: "28px", cursor: "pointer" }}
              src={addplus}
              alt="Add list"
              onClick={() => handleAddList(rowIndex)}
            />
          </Col>

          <Col md="3" lg="3">
            <div className="mt-2">
              <div
                className="more-btn d-flex align-items-center justify-content-center mb-3 "
                style={{
                  cursor: "pointer"
                }}
                onClick={() => row.attachment.length < 3 && handleAddFileUpload(rowIndex)}
              >
                <img
                  style={{ width: "28px", cursor: "pointer" }}
                  src={addplus}
                  alt="Add Image"
                />
                {" "}
                Add Image
              </div>
            </div>
          </Col>
          <br />
          {row.attachment && row.attachment.map((file: any, fileIndex: any) => (
            <div className="d-flex align-items-start mb-3"
              style={{ gap: "20px" }}>
              <Col lg="2" md="2">
                <Form.Select
                  aria-label="Select Priority"
                  name="priority"
                  value={file.priority || ""}
              required={!!row.title}
                  onChange={(e) => handlePriorityChange(e, rowIndex, fileIndex,file.id)}
                >
                  <option value="">Select Priority</option>
                  {getFilteredOptions(rowIndex, fileIndex).map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </Form.Select>
              </Col>


              <Col md="5" lg="5" key={fileIndex}>
                {isEmpty(file.imageName) && (

                  <div
                    className="file-upload"
                    onDrop={(e) => handleDrop(e, rowIndex, fileIndex,file.id)}
                    onDragOver={handleDragOver}
                  >
                    <input
                      type="file"
                      id={`file-input-${rowIndex}-${fileIndex}`}
                      required={!!row.title}
                      onChange={(e) => handleFileChange(e, rowIndex, fileIndex,file.id)}
                    />
                    <div
                      className="upload-icon"
                      onClick={() =>
                        document
                          .getElementById(`file-input-${rowIndex}-${fileIndex}`)
                          ?.click()
                      }
                    >
                      <img src={upload} alt="Upload Icon" />
                    </div>
                    <div className="drag-drop-area">
                      <p>
                        Drag and Drop file here or{" "}
                        <label
                          htmlFor={`file-input-${rowIndex}-${fileIndex}`}
                          style={{ cursor: "pointer" }}
                        >
                          Choose file
                        </label>
                      </p>
                      <p className="file-info">
                        Supported formats: JPEG, PNG, SVG.
                      </p>
                      <p style={{color:"red"}}>Minimum upload size (484px X 530px)</p>
                      
                      {file.imageType && (
                        <div className="file-info">
                          {file.imageType} file added
                        </div>
                      )}
                    </div>
                    {file.errorMessage && (
                      <div className="error-message">
                        {file.errorMessage}
                      </div>
                    )}
                  </div>
                )}

                {file.imageName && (
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                    }}
                  >
                    <img
                      src={file.imageName}
                      alt="Uploaded Icon"
                      style={{ width: "100px" }}
                    />
                    <span
                      style={{

                        cursor: "pointer",
                        fontSize: "18px",
                        backgroundColor: "white",
                        borderRadius: "50%",
                        padding: "2px 6px",
                        boxShadow: "0 0 5px rgba(0,0,0,0.3)",
                      }}
                      onClick={() => handleImageClose(rowIndex, fileIndex)}
                    >
                      &times;
                    </span>
                  </div>
                )}

              </Col>
              <Col md="3" lg="3" key={fileIndex}>

                <div className="ml-2">
                  <img
                    style={{
                      width: "28px",
                      cursor: "pointer",
                      marginLeft: "10px",
                    }}
                    src={MinusAdjustment}
                    alt="Remove Image"
                    onClick={() => handleRemoveFileUpload(rowIndex, fileIndex, file.id)}
                  />
                </div>
              </Col>

            </div>
          ))}


          <Col md="3" lg="3" className="flexalignitemstart">
            <div
              className="more-btn d-flex align-items-center justify-content-center mb-3 "
              style={{
                cursor: "pointer"
              }}
              onClick={() => handleRemoveRow(rowIndex, row.id)}
            >
              <img
                style={{ width: "28px", cursor: "pointer" }}
                src={MinusAdjustment}
                alt="Remove row"

              />
              {" "}
              Remove
            </div>
          </Col>
        </Row>
      ))}

      <Row>
        <Col md="2" lg="2" className="flexalignitemstart">
          <div
            className="more-btn d-flex align-items-center justify-content-center"
            onClick={handleAddRow}
          >
            <img
              style={{ marginRight: "10px", width: "12px", height: "12px" }}
              src={MinAdjustment}
              alt="Add row icon"
            />{" "}
            Add more
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ContentAdd;
